export const startRouteByRole = {
    finance: "/credit-logs",
    cUser: "/reports/shift-score",
    sOperation: "/map",
    sChef: "/map",
    hrEmployment: "/couriers",
    equipmentManager: "/equipments/requests",
    ik: "/couriers",
    seller: "/couriers",
    agency: "/anlik-operasyon",
    agencyIk: "/couriers",
    sales: "/orders",
    bm: "/anlik-operasyon",
    sy: "/anlik-operasyon",
    superadmin: "/anlik-operasyon",
    admin: "/anlik-operasyon",
    default: "/map"
};

export const getStartRoute = ({role, isPoolCustomer = false, isUatCustomer}) => {
    if (isUatCustomer && role === "cUser") {
        return "/musteri";
    }

    if (isPoolCustomer) {
        return "/create-delivery-request";
    }

    return startRouteByRole[role] || startRouteByRole.default;
};
